import type { EdgeStyle } from "../Graph.model";

const selectedEdgeStyle: Partial<EdgeStyle> = {
  underlayColor: "#17457b",
  underlayOpacity: 0.4,
  underlayPadding: 4,
};

export default selectedEdgeStyle;
